export const DECISION_TYPE = {
  INITIATE: 'INITIATE',
  SEND_BACK: 'SEND BACK',
  FORWARD: 'FORWARD',
  APPROVE: 'APPROVE',
  APPROVED: 'APPROVED',
  REJECT: 'REJECT',
  REJECTED: 'REJECTED',
};
